const Stock = {

    // FIELDS
    "department": "Department",
    "equipment": "Equipment",
    "part_number": "Part Number",
    "search": "Search",

    // PAGE HEADER
    "stock": "Stock Report",

    // TABLE HEADER
    "table_department": "DEPARTMENT",
    "table_equipment_name": "EQUIPMENT NAME",
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_installed_quantity": "INSTALLED QTY",
    "table_available_quantity": "AVAILABLE QTY",
}

export default Stock;
